import { cn } from "@babackapp/ui/lib/utils";
import { Column, Row } from "@react-email/components";
import type { RowBlockProps } from "./types";
import { Block, BlockType } from "../blocks-types";
import { getEditorBlockConfig } from "../index";


function EditorSubBlockRenderer({
  subBlock,
  blockProps,
}: {
  subBlock: Block
  blockProps: RowBlockProps
}) {
  const blockType = subBlock?.type as BlockType;
  const BlockComponent = getEditorBlockConfig(blockType);

  if (!BlockComponent?.EmailEditor) return null;

  return (
    <BlockComponent.EmailEditor
      {...blockProps}
      block={subBlock as never}
    />
  );
}


export function ButtonEmailRenderer({ isEditor, ...blockProps }: RowBlockProps & {
  isEditor?: boolean
}) {
  const subBlocks = blockProps.block.content?.children || [];
  const layout = blockProps.block.properties?.layout || "6-6";
  const layoutColsCount = layout.split("-").length;
  const verticalAlignment = blockProps.block.properties?.verticalAlignment || "top";
  const stackOnMobile = blockProps.block.properties?.stackOnMobile !== false;

  const verticalAlignValue = {
    top: "top",
    middle: "middle",
    bottom: "bottom"
  }[verticalAlignment];

  // Calculate width percentages based on layout
  const getColumnWidth = (index: number): string => {
    switch (layout) {
      case "6-6":
        return "50%";
      case "4-4-4":
        return "33.333%";
      case "3-3-3-3":
        return "25%";
      case "8-4":
        return index === 0 ? "33.333%" : "66.666%";
      case "4-8":
        return index === 0 ? "66.666%" : "33.333%";
      default:
        return `${100 / layoutColsCount}%`;
    }
  };

  return (
    <Row>
      {Array.from({ length: layoutColsCount }).map((_, index) => {
        const subBlock = subBlocks[index] || null;
        const columnWidth = getColumnWidth(index);

        return (
          <Column
            key={subBlock?.id || `empty-col-${index}`}
            style={{
              width: columnWidth,
              padding: 0,
              margin: 0,
              verticalAlign: verticalAlignValue,
            }}
            className={cn(
              stackOnMobile && "stack-on-mobile",
              isEditor && "border border-dashed border-muted-foreground/30 min-h-[60px]",
            )}
          >
            {subBlock ? (
              <EditorSubBlockRenderer subBlock={subBlock} blockProps={blockProps} />
            ) : isEditor ? (
              <div className="text-xs text-muted-foreground/50 select-none">
                Vide
              </div>
            ) : null}
          </Column>
        );
      })}
    </Row>
  );
}
